var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31045 4.11041C7.51874 3.90213 7.51874 3.56444 7.31045 3.35617C7.10218 3.14788 6.76449 3.14788 6.55621 3.35617L2.28955 7.62283C2.08126 7.83111 2.08126 8.1688 2.28955 8.37707L6.55621 12.6438C6.76449 12.852 7.10218 12.852 7.31045 12.6438C7.51874 12.4355 7.51874 12.0978 7.31045 11.8894L3.42092 7.99995L7.31045 4.11041ZM13.7105 4.11041C13.9187 3.90213 13.9187 3.56444 13.7105 3.35617C13.5022 3.14788 13.1645 3.14788 12.9562 3.35617L8.68955 7.62283C8.48126 7.83111 8.48126 8.1688 8.68955 8.37707L12.9562 12.6438C13.1645 12.852 13.5022 12.852 13.7105 12.6438C13.9187 12.4355 13.9187 12.0978 13.7105 11.8894L9.82092 7.99995L13.7105 4.11041Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/double-arrow-left.94acd7da6f877a1aa77b3fa3c15b0d10.svg";
export { ForwardRef as ReactComponent };